import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "moment-timezone";
import { fetchEnquiryList, getEnquiryById, createFollowup } from "../services/userservice";
import { Button, Modal } from "react-bootstrap";
// import { fetchEnquiryList } from "../../../services/userservice";
import * as moment from "moment";

const HolidayBookings = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");

  const [configurations, setConfigurations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [enquiryData, setEnquiryData] = useState();
  const [showEditModal, setShowEditModal] = useState(false);

  const fetchEnquiryData = (id) => {
    getEnquiryById(id)
      .then((response) => {
        setEnquiryData(response);
        setShowModal(true);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [followForm, setFollowForm] = useState({
    enquiry_id: "",
    next_followup_date: "",
    followed_by:"",
    service:"",
    remarks: "",
    status: "",
  });

  const openEditFollowup = (enq) => {
    const last = enq?.followups?.[enq.followups.length - 1];

    setFollowForm({
      enquiry_id: enq?.id,
      next_followup_date: last?.next_followup_date?.split("T")[0] || "",
      followed_by: last?.followed_by || "",
      remarks: last?.remarks || "",
      service: last?.service || "",
      status: last?.status || "PENDING",
    });

    setShowEditModal(true);
  };

  const submitFollowupForm = async () => {
    try {
      const payload = {
        id: followForm?.enquiry_id,
        next_followup_date: followForm?.next_followup_date,
        remarks: followForm?.remarks,
        service:followForm?.service,
        status: followForm?.status,
        followed_by: followForm?.followed_by,
      };

      await createFollowup(payload); 

      alert("Followup updated successfully!");

      setShowEditModal(false);
      window.location.reload(); // or re-fetch list
    } catch (error) {
      console.error(error);
      alert("Something went wrong");
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetchEnquiryList();
        setConfigurations(response?.data);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  if (loading) return <div>Loading...</div>;

  const filteredConfigurations = configurations.filter((configuration) =>
    configuration?.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Table rows to show per page Start

  const indexOfLastConfiguration = currentPage * rowsPerPage;
  const indexOfFirstConfiguration = indexOfLastConfiguration - rowsPerPage;
  const currentConfigurations = filteredConfigurations.slice(
    indexOfFirstConfiguration,
    indexOfLastConfiguration
  );

  // bottom pagination start

  const totalPages = Math.ceil(filteredConfigurations.length / rowsPerPage);

  const renderPageNumbers = () => {
    const pages = [];
    //const maxPagesToShow = 3;

    if (totalPages <= 10) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first 3 pages
      pages.push(1, 2, 3);

      // Show "..." if currentPage is beyond 5
      if (currentPage > 5) {
        pages.push("...");
      }

      // Show current page and neighbors
      const start = Math.max(4, currentPage - 1);
      const end = Math.min(totalPages - 3, currentPage + 1);

      for (let i = start; i <= end; i++) {
        if (!pages.includes(i)) pages.push(i);
      }

      // Show "..." if currentPage is far from end
      if (currentPage < totalPages - 4) {
        pages.push("...");
      }

      // Always show last 3 pages
      pages.push(totalPages - 2, totalPages - 1, totalPages);
    }

    return pages.map((page, index) => (
      <li
        key={index}
        className={`page-item ${page === currentPage ? "active" : ""} ${
          page === "..." ? "disabled" : ""
        }`}
      >
        {page === "..." ? (
          <span className="page-link">...</span>
        ) : (
          <button className="page-link" onClick={() => setCurrentPage(page)}>
            {page}
          </button>
        )}
      </li>
    ));
  };

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Holiday Bookings</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Home</Link>
                </li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="d-md-flex align-items-center justify-content-end">
                    <div className="card-tools">
                      <div
                        className="input-group input-group-sm"
                        style={{ width: "250px" }}
                      >
                        <input
                          type="text"
                          name="table_search"
                          className="form-control float-right"
                          placeholder="Search"
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <div className="input-group-append">
                          <button type="submit" className="btn btn-default">
                            <i className="fas fa-search" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                      <label className="me-2">Show</label>
                      <select
                        value={rowsPerPage}
                        onChange={(e) => {
                          setRowsPerPage(parseInt(e.target.value));
                          setCurrentPage(1); // Reset to first page
                        }}
                        className="form-control mx-2 form-select d-inline-block w-auto"
                      >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span className="ms-2">entries</span>
                    </div>
                    <div>
                      {/* Optional: Add search or pagination controls here */}
                    </div>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "10%" }}>Enquiry Type </th>
                          <th style={{ width: "15%" }}>Name</th>
                          <th style={{ width: "10%" }}>Mobile No.</th>
                          <th style={{ width: "15%" }}>Email No.</th>
                          <th style={{ width: "15%" }}>Package Name</th>
                          <th style={{ width: "10%" }}>AssignBy</th>
                          <th style={{ width: "10%" }}>Follow Date</th>
                          <th style={{ width: "10%" }}>Follow Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentConfigurations.map((configuration, i) => (
                          <tr key={configuration?.id}>
                            <td>{i + 1}</td>
                            <td>{configuration?.enquiry_type}</td>
                            <td>{configuration?.name}</td>
                            <td>{configuration?.mobile_number}</td>
                            <td>{configuration?.email}</td>
                            <td>
                              {configuration?.package?.package_name?.toUpperCase()}
                            </td>
                            <td>{configuration?.assign_by}</td>
                            <td>
                              {" "}
                              {moment(configuration?.followup_date).format(
                                "DD-MM-YY hh:mm A"
                              )}
                            </td>
                            <td>{configuration?.followup_status}</td>
                            <td>
                              <button
                                onClick={() =>
                                  fetchEnquiryData(configuration?.id)
                                }
                                className="btn btn-primary btn-sm"
                              >
                                View
                              </button>
                              <button
                                onClick={() => openEditFollowup(configuration)}
                                className="btn btn-primary btn-sm mx-2"
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="d-md-flex justify-content-between align-items-center mt-3">
                    <div>
                      Showing {indexOfFirstConfiguration + 1} to{" "}
                      {Math.min(
                        indexOfLastConfiguration,
                        filteredConfigurations.length
                      )}{" "}
                      of {filteredConfigurations.length} entries
                    </div>
                    <nav>
                      <ul className="pagination mb-0">
                        <li
                          className={`page-item ${
                            currentPage === 1 ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage - 1)}
                          >
                            Previous
                          </button>
                        </li>

                        {renderPageNumbers()}

                        <li
                          className={`page-item ${
                            currentPage === totalPages ? "disabled" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(currentPage + 1)}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg"
        className="custom-enquiry-modal"
      >
        <Modal.Header>
          <Modal.Title className="d-flex align-items-center">
            <i
              className="fa fa-envelope-open-text text-primary mx-2"
              style={{ color: "#fff" }}
            ></i>
            Enquiry Details
          </Modal.Title>
          <i
            className="fa fa-times close-icon"
            onClick={handleCloseModal}
            role="button"
            aria-label="Close Modal"
            title="Close"
          ></i>
        </Modal.Header>
        <Modal.Body className="p-0">
          <div className="modal-body-wrapper">
            <div className="enquiry-section">
              <h5 className="section-title">Personal Information</h5>
              <p>
                <strong>Name:</strong> {enquiryData?.name ?? "N/A"}
              </p>
              <p>
                <strong>Email:</strong> {enquiryData?.email ?? "N/A"}
              </p>
              <p>
                <strong>Mobile Number:</strong>{" "}
                {enquiryData?.mobile_number ?? "N/A"}
              </p>
            </div>
            <div className="enquiry-section">
              <h5 className="section-title">Enquiry Details</h5>
              <p>
                <strong>Type:</strong> {enquiryData?.enquiry_type ?? "N/A"}
              </p>
              <p>
                <strong>Package:</strong>{" "}
                {enquiryData?.package?.package_name ?? "Not Assigned"}
              </p>
              <p>
                <strong>Message:</strong>
                <br />
                <span className="text-muted">
                  {enquiryData?.message_content ?? "No message provided."}
                </span>
              </p>
            </div>
             <div className="enquiry-section">
  <h5 className="section-title">Followup Details</h5>

  {enquiryData?.followups?.length > 0 ? (
    <div className="table-responsive">
      <table className="table table-sm table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th style={{ width: "35%" }}>Remarks</th>
            <th>Status</th>
            <th>Next Follow-up Date</th>
            <th style={{ width: "35%" }}>Package/Service</th>
            <th>Followed By</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {enquiryData.followups.map((item, index) => (
            <tr key={item.id}>
              <td>{index + 1}</td>
              <td   style={{
          whiteSpace: "normal",
          wordBreak: "break-word",
        //   width: "35%",
          //maxWidth: "300px",
        }}>{item.remarks}</td>
              <td>{item.status}</td>
              <td>
                {item.next_followup_date
                  ? moment(item.next_followup_date).format("DD-MM-YYYY")
                  : "N/A"}
              </td>
              <td style={{
          whiteSpace: "normal",
          wordBreak: "break-word"}}>{item?.service}</td>
              <td>{item?.followed_by}</td>
              <td>{moment(item.created_at).format("DD-MM-YYYY hh:mm A")}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <p className="text-muted">No followup records available.</p>
  )}
</div>

            <div className="enquiry-section">
              <h5 className="section-title">Timestamps</h5>
              <p>
                <strong>Created At:</strong>{" "}
                {new Date(enquiryData?.created_at).toLocaleString() ?? "N/A"}
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
        size="md"
      >
        <Modal.Header>
          <Modal.Title>Edit Followup</Modal.Title>
          <i
            className="fa fa-times close-icon"
            onClick={() => setShowEditModal(false)}
          ></i>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Next Followup Date</label>
            <input
              type="date"
              className="form-control"
              value={followForm.next_followup_date}
              onChange={(e) =>
                setFollowForm({
                  ...followForm,
                  next_followup_date: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label"> Service</label>
            <input
              type="text"
              className="form-control"
              value={followForm.service}
              onChange={(e) =>
                setFollowForm({
                  ...followForm,
                  service: e.target.value,
                })
              }
            />
          </div>
          <div className="mb-3">
            <label className="form-label"> Followup By</label>
            <input
              type="text"
              className="form-control"
              value={followForm.followed_by}
              onChange={(e) =>
                setFollowForm({
                  ...followForm,
                  followed_by: e.target.value,
                })
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label d-block fw-semibold">Status</label>
            <select
              className="form-control"
               style={{ maxWidth: "100%" }}
              value={followForm.status}
              onChange={(e) =>
                setFollowForm({ ...followForm, status: e.target.value })
              }
            >
              <option value="PENDING">Pending</option>
              <option value="CONTACTED">Contacted</option>
              <option value="INTERESTED">Interested</option>
              <option value="NOT_INTERESTED">Not Interested</option>
              <option value="BOOKED">Booked</option>
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label">Remarks / Message</label>
            <textarea
              className="form-control"
              rows="3"
              value={followForm.remarks}
              onChange={(e) =>
                setFollowForm({ ...followForm, remarks: e.target.value })
              }
            ></textarea>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={submitFollowupForm}>
            Save
          </Button>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default HolidayBookings;
